<template>
  <div class="user-invitation-modal">
    <HMModalHeader :title="$t(title)" @close="$emit('close')" />
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form @submit.prevent="submitForm">
        <div class="row">
          <div class="col-12">
            <HMTextInput
              type="text"
              rules="required|email"
              :label="$t('GENERAL.LABEL.EMAIL')"
              v-model.trim="email"
              name="Email"
            />
          </div>
        </div>
        <HMModalFooter
          class="mt-3"
          :submitButton="$t('GENERAL.BUTTON.SEND_INVITE')"
          :disabled="invalid"
          :formError="formError"
          @close="$emit('close')"
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'HMUserInvitationModal',
  components: {
    ValidationObserver,
  },
  props: {
    title: {
      type: String,
      default: 'GENERAL.TITLE.INVITE_USER',
    },
    onSelect: { type: Function },
  },
  data() {
    return {
      email: '',
      formError: null,
    };
  },
  methods: {
    submitForm() {
      this.$emit('close');
      this.onSelect(this.email);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.user-invitation-modal {
  min-width: 300px;
}
</style>
